import { getFullPath } from 'lib/location'

export const getModalUrl = (location, path) => {
    const current = location
        ? getFullPath(location, { hash: false })
        : ''
    return `${current}#/modal/${path}`
}
